import * as React from "react"

export default class ProgressBar extends React.Component<Props> {

	constructor(props) {
		super(props)
	}
	render() {
    const { bgcolor, completed } = this.props;
    return  <div style={{ height: 20, backgroundColor: "#e0e0de", borderRadius: 50, margin: 50 }}>
                <div style={{ height: '100%', width: `${completed}%`, backgroundColor: bgcolor, borderRadius: 'inherit', textAlign: 'right' }}>
                    <span style={{ padding: 5, color: 'white', fontWeight: 'bold' }}>{`${completed}%`}</span>
                </div>
            </div>
	}
};

export interface Props {
	bgcolor: string,
	completed: any
}


// WEBPACK FOOTER //
// ./src/component/progress-loader/index.tsx